const $ = jQuery.noConflict();

'use strict';
let checkedInputIds = [];
const Wishlist = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */

	/** @description Initialize */
	init: function() {
		this.getCheckedIds();
		this.addToCart();
		this.removeFromWishList();

		if ($('body.logged-in').length > 0) {
			$('body').on('tinvwl_wishlist_ajax_response', function(event, post, data) {
				const counter = $('.js-wishlist-header-counter');
				counter.text(data.wishlists_data.counter);
			});
		}
	},

	getCheckedIds: function() {
		const wishlistBlock = $('#js-wishlist-block');
		if (!wishlistBlock) {
			return [];
		}

		wishlistBlock.on('change', 'input[type="checkbox"]', function() {
			checkedInputIds = [];
			const checkedInputs = document.querySelectorAll('input[type="checkbox"]:checked');
			if (checkedInputs) {
				for (let i = 0; i < checkedInputs.length; i++) {
					const attr = checkedInputs[i].getAttribute('data-id');
					if (attr) {
						checkedInputIds.push(checkedInputs[i].getAttribute('data-id'));
					}
				}
			}
			return checkedInputIds;
		});

		return [];
	},

	addToCart: function() {
		const buttons = document.querySelectorAll('.js-add-to-cart-wl');
		if (!buttons) {
			return false;
		}

		const addToCartAction = (e) => {
			const id = e.currentTarget.getAttribute('data-id');
			const qty = e.currentTarget.parentElement.parentElement.querySelector('.js-wishlist-qty').value;
			const data = {
				action: 'add_to_cart_from_wishlist',
				id,
				qty
			};
			document.body.classList.add('ajax-custom-action');
			Wishlist.ajaxFunction(data);
		};

		for (let i = 0; i < buttons.length; i++) {
			buttons[i].addEventListener('click', addToCartAction);
		}
	},

	removeFromWishList: function() {
		const btn = document.querySelector('.js-wishlist-block__upper-delete');
		if (!btn) {
			return false;
		}

		const removeProducts = () => {
			const checkedWishlistPRoducts = document.querySelectorAll('.js-wishlist-block__bottom-box-checkbox input[type="checkbox"]:checked');
			console.log(checkedWishlistPRoducts);
			if (checkedWishlistPRoducts.length < 1) {
				alert('Potrebno je da selektujete bar jedan proizvod');
				return;
			}
			const data = {
				action: 'remove_from_wishlist',
				ids: checkedInputIds
			};
			document.body.classList.add('ajax-custom-action');
			Wishlist.ajaxFunction(data);
		};

		btn.addEventListener('click', removeProducts);
	},

	ajaxFunction: function(data) {
		$.ajax({
			datatype: 'json',
			type: 'POST',
			/* eslint-disable */
			url: techno_ferum_ajax.ajax_url,
			/* eslint-disable */
			data,
			success: function(response) {
				console.log(response);
				const noProductsMsg = document.querySelector('.js-no-products-wishlist');
				if (response.success) {
					const data = response.data.data;
					const count = response.data.count;
					if (Array.isArray(data)) {
						for (let i = 0; i < data.length; i++) {
							const box = document.querySelector(`.js-wishlist-block__bottom-box[data-id="${data[i]}"]`);
							box.remove();
						}
					} else {
						const box = document.querySelector(`.js-wishlist-block__bottom-box[data-id="${data}"]`);
						box.remove();
					}
					$('.js-wishlist-header-counter').text(count);
				}
				document.body.classList.remove('ajax-custom-action');
				const boxes = document.querySelector('.js-wishlist-block__bottom-box');
				if (!boxes) {
					$('.wishlist-block__wrap').remove();
					noProductsMsg.style.display = 'block';
				}
			}
		});
	},
};

export default Wishlist;
